var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuertoRico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 0C10.7652 0 6.11797 2.51394 3.19897 6.4H28.8004C25.8814 2.51394 21.2342 0 15.9997 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 31.9999C21.2342 31.9999 25.8814 29.486 28.8004 25.5999H3.19897C6.11797 29.486 10.7652 31.9999 15.9997 31.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0002C0 17.0961 0.1105 18.1662 0.320437 19.2002H31.6797C31.8896 18.1662 32 17.0961 32 16.0002C32 14.9042 31.8895 13.8341 31.6796 12.8002H0.320437C0.1105 13.8341 0 14.9042 0 16.0002H0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68579 4.68628C-1.56258 10.9347 -1.56258 21.0653 4.68579 27.3138C7.26786 24.7317 9.75117 22.2484 15.9995 16L4.68579 4.68628Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47609 11.8262L7.51203 15.0147H10.8649L8.15253 16.9855L9.1884 20.1741L6.47609 18.2034L3.76365 20.1741L4.79978 16.9855L2.0874 15.0147H5.44003L6.47609 11.8262Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuertoRico);
export default __webpack_public_path__ + "static/media/puerto-rico.ffd95bcf.svg";
export { ForwardRef as ReactComponent };